import { CateringCategoryQuery } from 'components/pages/CateringPage/types/CateringCategoryQuery'
import Image from 'components/Image'
import Link from 'next/link'
import React from 'react'
import cn from 'classnames'
import { MarketsNearMeQuery } from 'components/pages/TrucksNearbyPage/types/marketsNearMe'

type Props = {
  foodTypePages:
    | NonNullable<CateringCategoryQuery['foodTypePages']>
    | NonNullable<MarketsNearMeQuery['foodTypePages']>
  title?: string
}

export default function FoodTypesSection({
  foodTypePages,
  title = 'Food truck catering cuisines'
}: Props) {
  if (foodTypePages.length === 0) return null

  return (
    <div className="relative bg-white lg:pt-24 pt-16">
      <div className="text-center">
        <h2 className="text-3xl font-extrabold text-gray-900 tracking-tight sm:text-4xl">
          {title}
        </h2>
      </div>
      <div className="mt-3 max-w-md mx-auto md:mt-5 md:max-w-3xl text-xl text-center">
        We have 80+ cuisines, here&apos;s just a few:
      </div>
      <div
        className="mt-12 max-w-lg mx-auto grid gap-5 grid-cols-3 lg:grid-cols-6 lg:max-w-none"
        style={{ justifyItems: 'center' }}
      >
        {foodTypePages.slice(0, 12).map((page, index) => (
          <Link key={page.id} href={page.customerPath}>
            <div
              aria-label={page.name}
              className={cn('relative', { 'hidden lg:block': index >= 6 })}
            >
              {page.image && (
                <div className="shadow rounded-lg flex overflow-hidden">
                  <Image
                    alt={page.name}
                    className="object-cover w-full object-center"
                    height={300}
                    src={page.image.url}
                    width={300}
                  />
                </div>
              )}
              <div>
                <p className="mt-2 mb-2 font-medium text-md lg:text-lg text-center text-orange-600 hover:text-orange-800 underline">
                  {page.name}
                </p>
              </div>
            </div>
          </Link>
        ))}
      </div>
    </div>
  )
}
